import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import PersonalDetailsIcon from "../assets/img/personal-details-icon.png";
import "../assets/css/candidate-tab-form.css";
import CallIcon from "../assets/img/call-icon.png";
import EmailIcon from "../assets/img/email-icon.png";
import { useDispatch, useSelector } from "react-redux";
import {
  personalReference,
  savePersonalReference,
  deleteSavePrReferenceDetails,
} from "../Actions/personalReferenceAction";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ABYear from "./Common/ABYear";
import ABUpload from "./Common/ABUpload";
import ABText1 from "./Common/ABText1";
import ABCarousel from "./ABCarousel";
import ABSelect from "./Common/ABSelect";
import GetMasterData from "./../Helper/masterData";
import InputField from "./InputField";
import Footer from "./Footer.js";
import StepCount from "./Common/StepCount";
import {
  validateEmail,
  validateMobileNumberNew,
  validateAlphabetsAndSpace,
} from "../Helper/common";
import Loader from "./Common/loader";
import { useParams } from "react-router-dom";
import $ from "jquery";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from "./Common/ProgressHeading.jsx";
const CandidatePersonalReference = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [newRecord, setNewRecord] = useState({});
  const [newRecord1, setNewRecord1] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [referenceData, setPersonalReferenceData] = useState({});
  const [referenceData1, setPersonalReferenceData1] = useState({});
  const [referenceData2, setPersonalReferenceData2] = useState({});
  const [errorData, setErrorData] = useState({});
  const storeData = useSelector((state) => state.personalReference);
  const [newValidationRecord, setNewValidationRecord] = useState({});
  const storeData2 = useSelector((state) => state.savePersonalReference);
  const dispatch = useDispatch();
  const [active, setActiveTab] = useState({});
  const [role,setRole]=useState();
  const {
    personalReferenceData,
    loading: getLoading,
    error: getError,
  } = storeData;
  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [getLoading]);
  const {
    savePersonalReferenceData,
    loading: saveLoading,
    error: saveError,
  } = storeData2;
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [saveLoading]);
  const [formError, setFormError] = useState({});
  const [reference, setReference] = useState();
  //const [group,setGroup]=useState();
  const [formVal, setFormVal] = useState({});

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);


  useEffect(() => {
    if (
      typeof personalReferenceData.data !== "undefined" &&
      personalReferenceData.data !== null
    ) {
      //setPersonalReferenceData(personalReferenceData.data.data.checksDetails[0]);
      setPersonalReferenceData(personalReferenceData.data.data);
      setPersonalReferenceData1(
        personalReferenceData.data.data.personal_ref_fieldsDataArr1
      );
      setPersonalReferenceData2(
        personalReferenceData.data.data.personal_ref_fieldsDataArr2
      );
      setActiveTab(
        personalReferenceData.data.data.checksDetails[0].case_check_id
      );
    }
  }, [personalReferenceData, storeData]);

  useEffect(() => {
    let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    setReference(list.reference_number);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(personalReference());
    };
    fetchData();
  }, []);
  let { activeTab, ddy } = useParams();
  //console.log(activeTab);
  useEffect(() => {
    //debugger;
    if (
      typeof savePersonalReferenceData !== "undefined" &&
      savePersonalReferenceData !== null &&
      savePersonalReferenceData.length != 0
    ) {
      const group = savePersonalReferenceData.group
        ? savePersonalReferenceData.group.group_id
        : "";
      const hasNextCheck =
        savePersonalReferenceData.nextCheck != "" ? true : false;
      const reference = savePersonalReferenceData.reference_number;

      if (!hasNextCheck) {
        if (group == "profile_preview") {
          navigate(`/case-initiation/profile-preview/${reference}`);
          dispatch(deleteSavePrReferenceDetails());
        } else if (typeof group != "undefined" && group != "") {
          navigate(`/case-initiation/check-detail/${reference}/${group}`);
          dispatch(deleteSavePrReferenceDetails());
        }
      } else {
        tabChange("key", savePersonalReferenceData.nextCheck);
        navigate(
          `/case-initiation/check-detail/${reference}/6/${savePersonalReferenceData.nextCheck}`
        );
        //setActiveTab(savePersonalReferenceData.nextCheck);

        dispatch(deleteSavePrReferenceDetails());
        window.scrollTo(0, 0);
      }
    }
  }, [savePersonalReferenceData, storeData2]);

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    referenceName: null,
    referenceRelation: null,
    email: null,
    mobile: null,
    referenceName2: null,
    referenceRelation2: null,
    email2: null,
    mobile2: null,
  });

  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const selectHandler = (value) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    // var cols = document.getElementsByClassName('err text-danger');
    // for (let i = 0; i < cols.length; i++) {
    //   cols[i].innerHTML = '';
    // }
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //let field_personal_reference_number = referenceData.fields.personal_reference_number;
    //checking if filed coming from api is mandatory
    if (value[0].name == "personal_reference_number_" + value[0].caseCheckId) {
      let fieldId = value[0].fieldId;
      let elementErrorId = "err_" + value[0].caseCheckId + "_" + fieldId;
      let elementName = "personal_reference_number";
      let elementValue = validateMobileNumberNew(value[0].value);
      if (elementValue == false) {
        document.getElementById(elementErrorId).innerHTML =
          "Please enter valid mobile number";
        isError = true;
      }
    }
    if (
      value[0].name ==
      "personal_reference_number_1_" + value[0].caseCheckId
    ) {
      let fieldId = value[0].fieldId;
      let elementErrorId = "err_" + value[0].caseCheckId + "_" + fieldId + "_1";
      let elementName = "personal_reference_number_1";
      let elementValue = validateMobileNumberNew(value[0].value);
      if (elementValue == false) {
        document.getElementById(elementErrorId).innerHTML =
          "Please enter a valid mobile number";
        isError = true;
      }
    }

    //let field_personal_reference_email = referenceData.fields.personal_reference_email;
    //checking if filed coming from api is mandatory
    if (
      value[0].value != "" &&
      value[0].name == "personal_reference_email_" + value[0].caseCheckId
    ) {
      let fieldId = value[0].fieldId;
      let elementErrorId = "err_" + value[0].caseCheckId + "_" + fieldId;
      let elementName = "personal_reference_email";
      let elementValue = validateEmail(value[0].value);
      if (elementValue == false) {
        document.getElementById(elementErrorId).innerHTML =
          "Please enter a valid email id";
        isError = true;
      }
    }
    if (
      value[0].value != "" &&
      value[0].name == "personal_reference_email_1_" + value[0].caseCheckId
    ) {
      let fieldId = value[0].fieldId;
      let elementErrorId = "err_" + value[0].caseCheckId + "_" + fieldId + "_1";
      let elementName = "personal_reference_email_1";
      let elementValue = validateEmail(value[0].value);
      if (elementValue == false) {
        document.getElementById(elementErrorId).innerHTML =
          "Please enter a valid email id";
        isError = true;
      }
    }
    /*if (isError == true) {
      var eleman = document.getElementById('savePersonalReference');
          eleman.setAttribute("disabled", "disabled");
    } else {
      var eleman = document.getElementById('savePersonalReference');
      eleman.removeAttribute("disabled");
    }*/

    if (
      value[0].name == "personal_reference_name_1_" + value[0].caseCheckId ||
      value[0].name ==
        "personal_reference_relation_1_" + value[0].caseCheckId ||
      value[0].name == "personal_reference_number_1_" + value[0].caseCheckId ||
      value[0].name == "personal_reference_email_1_" + value[0].caseCheckId
    ) {
      setNewRecord1((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value,
      }));
    } else {
      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: value[0].value,
      }));
    }

    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));

    // if (referenceData1[229] !== null && typeof referenceData1[229] !== "undefined" && referenceData1[229][0] !== '')
    // {
    //   let updatedOtherDetails = _.cloneDeep(referenceData1);
    //   if (value[0].name == 'personal_reference_name_1' || value[0].name == 'personal_reference_relation_1' || value[0].name == 'personal_reference_number_1' || value[0].name == 'personal_reference_email_1'){
    //     updatedOtherDetails[value[0].fieldId][1].stated_data = value[0].value;
    //   } else {
    //     updatedOtherDetails[value[0].fieldId][0].stated_data = value[0].value;
    //   }
    //  setPersonalReferenceData1(updatedOtherDetails);
    // }
  };

  const savePerReference = (e, caseCheckId, activeTabIndex) => {
    e.preventDefault();
    // debugger;
    console.log(activeTabIndex);
    const hasError = formValidation(caseCheckId, activeTabIndex);
    if (hasError == true) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      const recordData = {};
      recordData.case_check_id = caseCheckId;
      const obj = {
        group: "personal_reference",
        data: [{ ...newRecord }, { ...newRecord1 }],
      };
      recordData.check_data = { [caseCheckId]: obj };
      console.log(recordData);
      dispatch(savePersonalReference(recordData));
    }
  };

  const formValidation = (caseCheckId, activeTabIndex) => {
    let isError = false;
    //const newRecord = {};
    //const newRecord1 = {};
    // resetting all errors first
    var cols = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = "";
    }
    let activeTab = activeTabIndex - 1;
    let case_check_id = referenceData.checksDetails[activeTab].case_check_id;
    let field_personal_reference_name =
      referenceData.checksDetails[activeTab].fields.personal_reference_name;
    //checking if filed coming from api is mandatory
    if (field_personal_reference_name.is_mandatory == 1) {
      let fieldId = field_personal_reference_name.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "personal_reference_name_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value.trim() == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (
          elementValue === undefined ||
          elementValue === null ||
          elementValue.trim() == ""
        ) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        let elementValue = validateAlphabetsAndSpace(
          document.getElementById(elementName).value
        );
        if (elementValue === false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter valid input.";
          isError = true;
        } else {
          setNewRecord((prevState = {}) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }
      let fieldId1 = field_personal_reference_name.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "personal_reference_name_1_" + case_check_id;
      if (
        document.getElementById(elementName1).value == null ||
        document.getElementById(elementName1).value == ""
      ) {
        let elementValue1 = newValidationRecord[elementName1];
        if (elementValue1 === undefined || elementValue1 === null) {
          document.getElementById(elementErrorId1).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        let elementValue1 = validateAlphabetsAndSpace(
          document.getElementById(elementName1).value
        );
        if (elementValue1 === undefined || elementValue1 === false) {
          document.getElementById(elementErrorId1).innerHTML =
            "Please enter valid input.";
          isError = true;
        } else {
          setNewRecord1((prevState) => ({
            ...prevState,
            [fieldId1]: document.getElementById(elementName1).value,
          }));
        }
      }
    }

    let field_personal_reference_relation =
      referenceData.checksDetails[activeTab].fields.personal_reference_relation;
    //checking if filed coming from api is mandatory
    if (field_personal_reference_relation.is_mandatory == 1) {
      let fieldId = field_personal_reference_relation.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "personal_reference_relation_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        let elementValue = validateAlphabetsAndSpace(
          document.getElementById(elementName).value
        );
        if (elementValue === false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter valid input.";
          isError = true;
        } else {
          setNewRecord((prevState) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }
      let fieldId1 = field_personal_reference_relation.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "personal_reference_relation_1_" + case_check_id;
      if (
        document.getElementById(elementName1).value == null ||
        document.getElementById(elementName1).value == ""
      ) {
        let elementValue1 = newValidationRecord[elementName1];
        if (elementValue1 === undefined || elementValue1 === null) {
          document.getElementById(elementErrorId1).innerHTML =
            "This field is required.";
          isError = true;
        }
      } else {
        let elementValue1 = validateAlphabetsAndSpace(
          document.getElementById(elementName1).value
        );
        if (elementValue1 === false) {
          document.getElementById(elementErrorId1).innerHTML =
            "Please enter valid input.";
          isError = true;
        } else {
          setNewRecord1((prevState) => ({
            ...prevState,
            [fieldId1]: document.getElementById(elementName1).value,
          }));
        }
      }
    }

    let field_personal_reference_number =
      referenceData.checksDetails[activeTab].fields.personal_reference_number;
    //checking if filed coming from api is mandatory
    if (field_personal_reference_number.is_mandatory == 1) {
      let fieldId = field_personal_reference_number.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "personal_reference_number_" + case_check_id;
      if (
        document.getElementById(elementName).value == null ||
        document.getElementById(elementName).value == ""
      ) {
        let elementValue = newValidationRecord[elementName];
        if (elementValue === undefined || elementValue === null) {
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        } else {
          let elementValue2 = newValidationRecord[elementName];
          let elementValue3 = validateMobileNumberNew(elementValue2);
          if (elementValue3 == false) {
            document.getElementById(elementErrorId).innerHTML =
              "Please enter a valid mobile number";
            isError = true;
          }
        }
      } else {
        let elementValue3 = validateMobileNumberNew(
          document.getElementById(elementName).value
        );
        if (elementValue3 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid mobile number";
          isError = true;
        } else {
          setNewRecord((prevState) => ({
            ...prevState,
            [fieldId]: document.getElementById(elementName).value,
          }));
        }
      }
      let fieldId1 = field_personal_reference_number.id;
      let elementErrorId1 = "err_" + case_check_id + "_" + fieldId1 + "_1";
      let elementName1 = "personal_reference_number_1_" + case_check_id;
      if (
        document.getElementById(elementName1).value == null ||
        document.getElementById(elementName1).value == ""
      ) {
        let elementValue1 = newValidationRecord[elementName1];
        if (elementValue1 === undefined || elementValue1 === null) {
          document.getElementById(elementErrorId1).innerHTML =
            "This field is required.";
          isError = true;
        } else {
          let elementValue2 = newValidationRecord[elementName1];
          let elementValue3 = validateMobileNumberNew(elementValue2);
          if (elementValue3 == false) {
            document.getElementById(elementErrorId1).innerHTML =
              "Please enter a valid mobile number";
            isError = true;
          }
        }
      } else {
        let elementValue3 = validateMobileNumberNew(
          document.getElementById(elementName1).value
        );
        if (elementValue3 == false) {
          document.getElementById(elementErrorId1).innerHTML =
            "Please enter a valid mobile number";
          isError = true;
        } else {
          setNewRecord1((prevState) => ({
            ...prevState,
            [fieldId1]: document.getElementById(elementName1).value,
          }));
        }
      }
    }
    let field_personal_reference_email =
      referenceData.checksDetails[activeTab].fields.personal_reference_email;
    //checking if filed coming from api is mandatory
    if (field_personal_reference_email.is_mandatory == 0) {
      let fieldId = field_personal_reference_email.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "personal_reference_email_" + case_check_id;
      let elementValue = newValidationRecord[elementName];
      if (elementValue != "" && elementValue != null) {
        let elementValue1 = validateEmail(elementValue);
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid email id";
          isError = true;
        }
      } else {
        setNewRecord((prevState) => ({
          ...prevState,
          [fieldId]: document.getElementById(elementName).value,
        }));
      }
    }
    if (field_personal_reference_email.is_mandatory == 0) {
      let fieldId = field_personal_reference_email.id;
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_1";
      let elementName = "personal_reference_email_1_" + case_check_id;
      let elementValue = newValidationRecord[elementName];
      if (elementValue != "" && elementValue != null) {
        let elementValue1 = validateEmail(elementValue);
        if (elementValue1 == false) {
          document.getElementById(elementErrorId).innerHTML =
            "Please enter a valid email id";
          isError = true;
        }
      } else {
        setNewRecord1((prevState) => ({
          ...prevState,
          [fieldId]: document.getElementById(elementName).value,
        }));
      }
    }

    return isError;
  };

  const tabChange = (index, caseCheckId) => {
    if (
      typeof referenceData.checksDetails !== "undefined" &&
      referenceData.checksDetails !== null
    ) {
      const reference = referenceData.referenceNo;
      if (caseCheckId) {
        let refData11 = referenceData1;
        let refData12 = referenceData2;
        let refData1 = "";
        let refData2 = "";
        if (typeof refData11 !== "undefined" && refData11 != null) {
          refData1 = refData11[caseCheckId];
          if (typeof refData1 !== "undefined" && refData1 != null) {
            Object.entries(refData1).map(([key, value]) => {
              setNewRecord((prevState = {}) => ({
                ...prevState,
                [value[0].field_id]: value[0].stated_data,
              }));
            });
          }

          if (typeof refData12 !== "undefined" && refData12 != null) {
            refData2 = refData12[caseCheckId];
            if (typeof refData2 !== "undefined" && refData2 != null) {
              Object.entries(refData2).map(([key, value]) => {
                setNewRecord1((prevState = {}) => ({
                  ...prevState,
                  [value[1].field_id]: value[1].stated_data,
                }));
              });
            }
          }
        }
        setActiveTab(caseCheckId);
        navigate(`/case-initiation/check-detail/${reference}/6/${caseCheckId}`);
      }
    }
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  return (
    <>
      {isLoading && <Loader />}
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}
      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
             <ProgressHeading/>
              <CandidateTab activeTab={"Personal Reference"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}
              <form ref={form} className="p-3 form2 form-section">
                <StepCount activeTab={"Personal Reference"} />
                <h2 className="fnt-smi-bld">Personal Reference</h2>
                {/*<p className="text-muted">To obtain Credit information report from credit bureau kindly sure that enterd mobile.</p>
                 */}
                <hr />
                <div className="d-flex justify-content-between align-items-center">
                  <ul
                    className="nav nav-tabs address-tabs"
                    id="myTab"
                    role="tablist"
                  >
                    {referenceData.checksDetails &&
                      Object.entries(referenceData.checksDetails).map(
                        ([key, value]) => {
                          const index = parseInt(key) + 1;
                          const caseCheckId = value.case_check_id;
                          let activeClass = "";
                          if (typeof active !== "undefined") {
                            if (active == caseCheckId) {
                              activeClass = "active";
                            }
                          } else if (index === 1) {
                            activeClass = "active";
                          }
                          let check_name = value.IB_CHECK_NAME;
                          const caseCheckStatus = value.check_status;
                          let completeClass = "";
                          if (caseCheckStatus === 2) {
                            completeClass = "completed";
                          }
                          return (
                            <li
                              className={`nav-item ${completeClass}`}
                              key={key}
                            >
                              <a
                                className={`tab nav-link ${activeClass} ${completeClass}`}
                                id={`personal-ref-tab-${index}`}
                                data-toggle="tab"
                                href={`#personal-ref-${index}`}
                                role="tab"
                                aria-controls={`personal-ref-${index}`}
                                aria-selected="true"
                                data-index={index - 1}
                                data-casecheckid={caseCheckId}
                                onClick={() => tabChange(key, caseCheckId)}
                              >
                                {caseCheckStatus === 2 && (
                                  <i class="fas fa-check-circle mr-1"></i>
                                )}
                                {check_name}
                              </a>
                            </li>
                          );
                        }
                      )}
                  </ul>
                </div>

                <div className="tab-content" id="myTabContent">
                  {referenceData.checksDetails &&
                    Object.entries(referenceData.checksDetails).map(
                      ([key, value]) => {
                        const index = parseInt(key) + 1;
                        const caseCheckId = value.case_check_id;
                        let activeClass = "";
                        if (typeof active !== "undefined") {
                          if (active == caseCheckId) {
                            activeClass = "show active";
                          }
                        } else if (index === 1) {
                          activeClass = "show active";
                        }
                        let refData1 = "";
                        let refData2 = "";
                        if (
                          typeof referenceData1 !== "undefined" &&
                          referenceData1 != null
                        ) {
                          refData1 = referenceData1[caseCheckId];
                        }
                        if (
                          typeof referenceData2 !== "undefined" &&
                          referenceData2 != null
                        ) {
                          refData2 = referenceData2[caseCheckId];
                        }
                        return (
                          <div
                            className={`tab-pane fade ${activeClass}`}
                            id={`personal-ref-${index}`}
                            role="tabpanel"
                            aria-labelledby={`personal-ref-tab-${index}`}
                            key={key}
                          >
                            {value.is_form_required == 1 && (
                              <h6 className="fnt-smi-bld mb-3">Reference 1</h6>
                            )}
                            {value.is_form_required == 1 && (
                              <div className="row">
                                {value.fields.personal_reference_name ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_name_${caseCheckId}`}
                                      id={`personal_reference_name_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_name.id
                                      }
                                      label={
                                        value.fields.personal_reference_name
                                          .label
                                      }
                                      isRequired={1}
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_name.id}`}
                                      value={
                                        typeof refData1 !== "undefined" &&
                                        refData1 != null &&
                                        refData1[229] !== null &&
                                        typeof refData1[229] !== "undefined" &&
                                        refData1[229][0] !== ""
                                          ? refData1[229][0].stated_data
                                          : ""
                                      }
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {value.fields.personal_reference_relation ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_relation_${caseCheckId}`}
                                      id={`personal_reference_relation_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_relation
                                          .id
                                      }
                                      label={
                                        value.fields.personal_reference_relation
                                          .label
                                      }
                                      isRequired={1}
                                      value={
                                        typeof refData1 !== "undefined" &&
                                        refData1 != null &&
                                        refData1[230] !== null &&
                                        typeof refData1[230] !== "undefined" &&
                                        typeof refData1[230][0] !==
                                          "undefined" &&
                                        refData1[230] !== ""
                                          ? refData1[230][0].stated_data
                                          : ""
                                      }
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_relation.id}`}
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            )}
                            {value.is_form_required == 1 && (
                              <div className="row">
                                {value.fields.personal_reference_number ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_number_${caseCheckId}`}
                                      id={`personal_reference_number_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_number
                                          .id
                                      }
                                      label={
                                        value.fields.personal_reference_number
                                          .label
                                      }
                                      isRequired={1}
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_number.id}`}
                                      value={
                                        typeof refData1 !== "undefined" &&
                                        refData1 != null &&
                                        refData1[231] !== null &&
                                        typeof refData1[231] !== "undefined" &&
                                        typeof refData1[231][0] !==
                                          "undefined" &&
                                        refData1[231] !== ""
                                          ? refData1[231][0].stated_data
                                          : ""
                                      }
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {value.fields.personal_reference_email ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_email_${caseCheckId}`}
                                      id={`personal_reference_email_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_email.id
                                      }
                                      label={
                                        value.fields.personal_reference_email
                                          .label
                                      }
                                      value={
                                        typeof refData1 !== "undefined" &&
                                        refData1 != null &&
                                        refData1[232] !== null &&
                                        typeof refData1[232] !== "undefined" &&
                                        typeof refData1[232][0] !==
                                          "undefined" &&
                                        refData1[232] !== ""
                                          ? refData1[232][0].stated_data
                                          : ""
                                      }
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_email.id}`}
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            )}
                            {value.is_form_required == 1 && (
                              <h6 className="fnt-smi-bld mb-3">Reference 2</h6>
                            )}
                            {value.is_form_required == 1 && (
                              <div className="row">
                                {value.fields.personal_reference_name ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_name_1_${caseCheckId}`}
                                      id={`personal_reference_name_1_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_name.id
                                      }
                                      label={
                                        value.fields.personal_reference_name
                                          .label
                                      }
                                      isRequired={1}
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_name.id}_1`}
                                      value={
                                        typeof refData2 !== "undefined" &&
                                        refData2 != null &&
                                        refData2[229] !== null &&
                                        typeof refData2[229] !== "undefined" &&
                                        typeof refData2[229][1] !==
                                          "undefined" &&
                                        refData2[229] !== ""
                                          ? refData2[229][1].stated_data
                                          : ""
                                      }
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {value.fields.personal_reference_relation ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_relation_1_${caseCheckId}`}
                                      id={`personal_reference_relation_1_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_relation
                                          .id
                                      }
                                      label={
                                        value.fields.personal_reference_relation
                                          .label
                                      }
                                      isRequired={1}
                                      value={
                                        typeof refData2 !== "undefined" &&
                                        refData2 != null &&
                                        refData2[230] !== null &&
                                        typeof refData2[230] !== "undefined" &&
                                        typeof refData2[230][1] !==
                                          "undefined" &&
                                        refData2[230] !== ""
                                          ? refData2[230][1].stated_data
                                          : ""
                                      }
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_relation.id}_1`}
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            )}
                            {value.is_form_required == 1 && (
                              <div className="row">
                                {value.fields.personal_reference_number ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_number_1_${caseCheckId}`}
                                      id={`personal_reference_number_1_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_number
                                          .id
                                      }
                                      label={
                                        value.fields.personal_reference_number
                                          .label
                                      }
                                      isRequired={1}
                                      value={
                                        typeof refData2 !== "undefined" &&
                                        refData2 != null &&
                                        refData2[231] !== null &&
                                        typeof refData2[231] !== "undefined" &&
                                        typeof refData2[231][1] !==
                                          "undefined" &&
                                        refData2[231] !== ""
                                          ? refData2[231][1].stated_data
                                          : ""
                                      }
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_number.id}_1`}
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                                {value.fields.personal_reference_email ? (
                                  <>
                                    <ABText1
                                      caseCheckId={caseCheckId}
                                      name={`personal_reference_email_1_${caseCheckId}`}
                                      id={`personal_reference_email_1_${caseCheckId}`}
                                      fieldId={
                                        value.fields.personal_reference_email.id
                                      }
                                      value={
                                        typeof refData2 !== "undefined" &&
                                        refData2 != null &&
                                        refData2[232] !== null &&
                                        typeof refData2[232] !== "undefined" &&
                                        typeof refData2[232][1] !==
                                          "undefined" &&
                                        refData2[232] !== ""
                                          ? refData2[232][1].stated_data
                                          : ""
                                      }
                                      label={
                                        value.fields.personal_reference_email
                                          .label
                                      }
                                      errId={`err_${caseCheckId}_${value.fields.personal_reference_email.id}_1`}
                                      inputText={selectHandler}
                                    />
                                    <p className="err text-danger">
                                      {formError.formVal1}
                                    </p>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            )}
                            {value.is_form_required == 1 && (
                              <div className="row mt-3">
                                <div className="col-auto d-flex justify-content-between">
                                  {/* <button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">Back</button> */}
                                  <button
                                    className="btn btn-primary btn-lg btn-block mt-3"
                                    id="savePersonalReference"
                                    onClick={(e) =>
                                      savePerReference(
                                        e,
                                        value.case_check_id,
                                        index
                                      )
                                    }
                                  >
                                    Save
                                  </button>
                                </div>
                              </div>
                            )}
                            {referenceData.showProfilePreview == 1 && (
                              <div className="row">
                                <div className="col-auto d-flex justify-content-between">
                                  <button
                                    className="btn btn-primary btn-lg btn-block mt-3"
                                    onClick={(e) => handleSubmitForPreview(e)}
                                  >
                                    {clientId == 459831 ? "Preview" : "Submit for Preview"}
                                  </button>
                                </div>
                                <div className="col-auto d-flex justify-content-between mt-4">
                                  <small className="text-muted">
                                    Please complete all the mandatory fields
                                    before final submission
                                  </small>
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      }
                    )}
                </div>
              </form>
              {/*Form*/}
              <div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    {/* <button className="btn btn-primary btn-lg mr-3">Submit for Preview</button>
                    <span className="text-muted">Please complete the all mandatory fields before final submission</span>*/}
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default CandidatePersonalReference;
